import { useSlots as _useSlots, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

interface Props {
  text: string;
  color?: string;
  height?: string | number;
  align?: 'left' | 'center' | 'right';
  padding?: string;
  size?: string;
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'Divider',
},
  __name: 'index',
  props: {
    text: { default: '分割线' },
    color: { default: '#000' },
    height: { default: 'auto' },
    align: { default: 'left' },
    padding: { default: '10px' },
    size: { default: '16px' }
  },
  setup(__props: any) {

const slots = _useSlots();
const props = __props;



return (_ctx: any,_cache: any) => {
  const _component_taro_view = _resolveComponent("taro-view")!

  return (_openBlock(), _createBlock(_component_taro_view, {
    class: "font-bold text-op-10 px-0!",
    style: _normalizeStyle({
      height: props.height,
      color: props.color,
      padding: props.padding,
      textAlign: _ctx.align,
      fontSize: _ctx.size,
    })
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode(_toDisplayString(props.text), 1)
      ])
    ]),
    _: 3
  }, 8, ["style"]))
}
}

})